import React from "react";
import ClientAppointments from "./client-appointments";
import ClientDiagnosis from "./client-diagnosis";
import ClientDiary from "./client-diary";
import ClientHistory from "./client-history";
import ClientMain from "./client-main";
import "./client.css";

export const CLIENT_TAB_KEYS = {
  MAIN: "main",
  APPOINTMENTS: "appointments",
  HISTORY: "history",
  DIARY: "diary",
  DIAGNOSIS: "diagnosis"
};

export const CLIENT_TAB_ITEMS = [
  { key: CLIENT_TAB_KEYS.MAIN, label: "Основная" },
  { key: CLIENT_TAB_KEYS.APPOINTMENTS, label: "Назначения" },
  { key: CLIENT_TAB_KEYS.HISTORY, label: "История болезни" },
  { key: CLIENT_TAB_KEYS.DIARY, label: "Дневник" },
  { key: CLIENT_TAB_KEYS.DIAGNOSIS, label: "Диагноз" }
];

/**
 * Карточка клиента: контент активной вкладки.
 */
const Client = ({ idClient, isNew = false, open, activeTab, onSaved, onCancel }) => {
  const tabProps = { idClient, isNew, open, onSaved, onCancel };

  if (isNew) {
    return <ClientMain {...tabProps} />;
  }

  switch (activeTab) {
    case CLIENT_TAB_KEYS.APPOINTMENTS:
      return <ClientAppointments {...tabProps} />;
    case CLIENT_TAB_KEYS.HISTORY:
      return <ClientHistory {...tabProps} />;
    case CLIENT_TAB_KEYS.DIARY:
      return <ClientDiary {...tabProps} />;
    case CLIENT_TAB_KEYS.DIAGNOSIS:
      return <ClientDiagnosis {...tabProps} />;
    case CLIENT_TAB_KEYS.MAIN:
    default:
      return <ClientMain {...tabProps} />;
  }
};

export default Client;
